import React from 'react';
import './App.css';
import { Box, Tooltip } from '@mui/material';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource-variable/inter';
import './theme/ui.css';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { ConfigProvider, theme as antdTheme } from 'antd';
import { buildTheme, fontFamily, resolveMode } from './theme/theme';

import Home from './Pages/Home';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import NotFound from './Pages/NotFound';
import About from './Pages/About';
import Contact from './Pages/Contact';
import { BrowserUpdated, Code, ContactsRounded, HomeOutlined } from '@mui/icons-material';
import CookieConsent from './Components/CookieConsent';
import Carriere from './Pages/Carriere';
import Articles from './Pages/Articles';
import { useTranslation } from 'react-i18next';
import FocusIA from './Pages/FocusIA';
import FocusAI from './Pages/FocusAI';
import ProductPage from './Pages/ProductPage';
import { Analytics } from "@vercel/analytics/react"
import imageIa from './Files/ia.png'

function App() {

  localStorage.setItem("mode", "light")
  const navigate = useNavigate()
  const { t } = useTranslation();
  const mode = resolveMode();
  const muiTheme = React.useMemo(() => buildTheme(mode), [mode]);
  document.documentElement.dataset.theme = mode;

  const handleClick = (event: React.MouseEvent<HTMLDivElement>, link: string) => {
    navigate(link)
    const anchor =
      (
        (event.target as HTMLDivElement).ownerDocument || document
      ).querySelector(link.includes("#") ? ("#" + link.split("#")[1]) : "#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    }
  };
  return (
    <ThemeProvider theme={muiTheme}>
    <CssBaseline />
    <ConfigProvider theme={{ algorithm: mode === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm, token: { fontFamily, colorPrimary: mode === 'dark' ? '#8EA2FF' : '#191C60', borderRadius: 10 } }}>
      <div draggable={false} className="App">
        <CookieConsent />
        <Box component="nav" className="raccourci">
          <Tooltip title={t("accueil")} placement="right"><button aria-label={t("accueil")} onClick={(e: any) => { (handleClick(e, "/")) }}><HomeOutlined /></button></Tooltip>
          <Tooltip title={t("contact")} placement="right"><button aria-label={t("contact")} onClick={(e: any) => { (handleClick(e, "/contact")) }}><ContactsRounded /></button></Tooltip>
          <Tooltip title={t("services")} placement="right"><button aria-label={t("services")} onClick={(e: any) => { (handleClick(e, "/#services")) }}><BrowserUpdated /></button></Tooltip>
          <Tooltip title={t("produit")} placement="right"><button aria-label={t("produit")} onClick={(e: any) => { (handleClick(e, "/#products")) }}><Code /></button></Tooltip>
          <Tooltip title={t("titrePage.FocusAI.titre")} placement="right"><button aria-label={t("titrePage.FocusAI.titre")} onClick={(e: any) => { (handleClick(e, "/focusia")) }}><img src={imageIa} alt="" /></button></Tooltip>
        </Box>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/uses' element={<Navigate to='/' replace />} />
          <Route path='/projects' element={<Navigate to='/#products' replace />} />
          <Route path='/products' element={<Navigate to='/#products' replace />} />
          <Route path='/products/:slug' element={<ProductPage />} />
          <Route path='/services' element={<Navigate to='/#services' replace />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/career' element={<Carriere />} />
          <Route path='/articles' element={<Articles />} />
          <Route path='/articles/*' element={<Articles />} />
          <Route path='/focusia' element={<FocusAI />} />
          <Route path='/focusia/chat' element={<FocusIA />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </div>
      <Analytics />
    </ConfigProvider>
    </ThemeProvider>
  );
}

export default App;
